import React from 'react';
import FormationHub from '../formation/FormationHub';

interface MemberFormationProps {
    memberData?: any;
}

const MemberFormation: React.FC<MemberFormationProps> = ({ memberData }) => {
    const memberId = memberData?.id || 'member-id-placeholder';

    return (
        <div className="min-h-screen bg-gray-50">
            <FormationHub memberId={memberId} />
        </div>
    );
};

export default MemberFormation;